import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import RatingWrapper from './components/RatingWrapper'
import { useTranslation } from 'react-i18next'
import CurrrentRating from './components/CurrrentRating'
import EmojisForRating from './components/EmojisForRating'
import { useDispatch } from 'react-redux'
import { mixrActions } from 'srcReact/Mixr/actions'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'
import WriteReviewModal from './components/WriteReviewModal'
import ReviewListModal from './components/ReviewListModal'
import RateMixrModal from './components/RateMixrModal'

function MixrRating({ isMobileDevice, loading, error, success, ratingData, mixrData, loggedUserId }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [orgId, setOrgId] = useState(0)
  const [isWriteReviewModalOpen, setIsWriteReviewModalOpen] = useState(false)
  const [isReviewListModalOpen, setIsReviewListModalOpen] = useState(false)
  const [loggedUserReview, setLoggedUserReview] = useState(null)

  useEffect(() => {
    const organizationId = getCurrentOrgId()
    setOrgId(organizationId)
  }, [])

  useEffect(() => {
    if (ratingData?.ratings_and_reviews?.user_ratings?.length > 0) {
      const user = ratingData.ratings_and_reviews.user_ratings.find((u) => u.user_id === loggedUserId)
      if (user) {
        setLoggedUserReview(user)
      }
    }
  }, [ratingData])

  const openWriteReviewModal = () => {
    setIsWriteReviewModalOpen(true)
  }
  const closeWriteReviewModal = () => {
    setIsWriteReviewModalOpen(false)
  }

  const openReviewListModal = () => {
    setIsReviewListModalOpen(true)
  }
  const closeReviewListModal = () => {
    setIsReviewListModalOpen(false)
  }

  const handleRateMixr = (value, isPublic = 1, reviewMessage = '') => {
    dispatch(
      mixrActions.updateMixrRating(orgId, mixrData.id, isPublic, value, reviewMessage || loggedUserReview?.review, true)
    )
  }
  return (
    <div className={styles.mixrRatingWrapper}>
      {ratingData && ratingData.mixr_rating > 0 && ratingData.ratings_and_reviews?.rating_count > 0 && (
        <RatingWrapper
          title={t('rating.mixrRatingTitle')}
          renderFooter={() => (
            <p aria-label='Total ratings'>
              {t('rating.mixrrating', { count: ratingData.ratings_and_reviews.rating_count })}
            </p>
          )}>
          <CurrrentRating size='large' showRating={true} rating={ratingData.mixr_rating} />
        </RatingWrapper>
      )}
      <RatingWrapper title={loggedUserReview?.rating > 0 ? t('rating.yourRating') : t('rating.rateMixrTitle')}>
        <EmojisForRating
          selectedValue={loggedUserReview?.rating}
          size='large40'
          className={styles.emojis}
          handleRateMixr={handleRateMixr}
        />
      </RatingWrapper>
      <RatingWrapper
        title={t('rating.review.leaveReview')}
        renderFooter={() =>
          ratingData.ratings_and_reviews.review_count > 0 ? (
            <Button
              handleClick={openReviewListModal}
              customStyle={styles.btnReviewCount}
              text={t('rating.review.reviewcount', { count: ratingData.ratings_and_reviews.rating_count })}
              iconPosition={'end'}
              icon={<Icon name='arrow-right' size='large24' />}
            />
          ) : (
            <p className={`${styles.btnReviewCount} ${styles.noreviewText}`}>{t('rating.review.noReview')}</p>
          )
        }>
        <Button
          customStyle={styles.btnWriteReview}
          text={loggedUserReview?.review ? t('rating.review.editReview') : t('rating.review.writeReview')}
          size='large'
          handleClick={openWriteReviewModal}
          iconPosition={'start'}
          icon={<Icon styleModifier={styles.icon} name='write' size='large24' />}
        />
      </RatingWrapper>
      {isWriteReviewModalOpen && (
        <WriteReviewModal
          currentReview={loggedUserReview?.review}
          selectedRatingValue={loggedUserReview?.rating}
          showSendMessageOptions={false}
          isMobileDevice={isMobileDevice}
          isOpen={isWriteReviewModalOpen}
          handleRateMixr={handleRateMixr}
          closeModal={closeWriteReviewModal}
          loading={loading}
          error={error}
          success={success}
        />
      )}
      {isReviewListModalOpen && (
        <ReviewListModal
          mixrId={mixrData.id}
          currentReview={loggedUserReview?.review}
          ratingData={ratingData}
          isOpen={isReviewListModalOpen}
          closeModal={closeReviewListModal}
          isMobileDevice={isMobileDevice}
          openWriteReviewModal={openWriteReviewModal}
        />
      )}
    </div>
  )
}

export default MixrRating
